import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import BorderIcon from "../assets/SVG/borderIcon";
import CalendarIcon from "../assets/SVG/calendarIcon";
import FlagIcon from "../assets/SVG/flagIcon";
import CreateTripPop from "../pages/leaderGroup/createTripPop";
import AddFlagIcon from "./addFlagIcon";
import CreateGroupPop from "./createGroupPop";

export default function DashboardGroup({ data, leader }) {
  const [anchorEl, setAnchorEl] = useState();
  const [dataSelected, setDataSelected] = useState();
  const dataViewGroupInfo = [
    { title: "مراجعین", count: data?.postRef },
    { title: "جهادگران", count: data?.members },
    { title: "هزینه خدمات", count: data?.totalCosts },
    { title: "مراجعین پس از اردو", count: data?.totalRefs },
    { title: "جراحی‌ها", count: data?.surgeries },
  ];
  // console.log(data);
  const arrNumber = [
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
    "ده",
    "یازده",
  ];
  return (
    <>
      <CreateTripPop
        dataGroup={data}
        dataSelected={dataSelected}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
      />
      <Box gap="15px" display={"flex"} mt="20px" flexWrap="wrap">
        {data?.activeProjects.length >= 1 && (
          <>
            <Box
              p="10px"
              bgcolor="#F5F9FF"
              borderRadius="12px"
              width="240px"
              height="170px"
              boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
              sx={{ overflow: "auto" }}
            >
              <Box
                sx={{
                  overflow: "auto",
                  height: "100%",
                  px: "5px",
                  direction: "ltr",
                  "::-webkit-scrollbar-thumb": {
                    background: "#126E83",
                    // borderRadius: "10px"
                  },
                  "::-webkit-scrollbar-track": {
                    background: "#A7C9D1",
                    borderRadius: "10px",
                  },
                }}
              >
                {data?.activeProjects?.map((x, i) => (
                  <Box sx={{ direction: "rtl" }} px="10px">
                    <Typography
                      fontWeight="bold"
                      color="var(--emr-font)"
                      fontSize={"20px"}
                      mt="25px"
                    >
                      {`پروژه ${arrNumber[i]}`}
                    </Typography>

                    {x.tripIds?.map((z, i) => (
                      <>
                        <Box mt="20px" display={"flex"}>
                          <FlagIcon
                            color={
                              x.color === "white"
                                ? "white"
                                : `var(--emr-${x.color})`
                            }
                          />
                          <Typography
                            mr="8px"
                            fontSize={"14px"}
                            color="#6C6969"
                          >
                            {x.name + "-" + (i + 1)}
                          </Typography>
                        </Box>
                        <Box mt="15px" display={"flex"}>
                          <CalendarIcon />
                          <Typography
                            mr="8px"
                            fontSize={"14px"}
                            color="#6C6969"
                          >
                            {`${x.startAt.split(" ", 1)[0]} تا ${
                              x.endAt.split(" ", 1)[0]
                            }`}
                          </Typography>
                        </Box>
                        <Box
                          sx={{ cursor: "pointer" }}
                          mt="15px"
                          display={"flex"}
                          onClick={(e) => {
                            if (leader) {
                              setAnchorEl(e.currentTarget);
                              setDataSelected(z);
                            }
                          }}
                        >
                          <AddFlagIcon />
                          <Typography
                            mr="8px"
                            fontSize={"14px"}
                            color="var(--emr-darkblue)"
                          >
                            {"ساخت اردو"}
                          </Typography>
                        </Box>
                      </>
                    ))}
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        )}
        <Box
          p="10px"
          bgcolor="#F5F9FF"
          borderRadius="12px"
          width="240px"
          height="170px"
          boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
        >
          <Box
            // mr="10px"

            sx={{
              overflow: "auto",
              height: "100%",
              px: "10px",
              direction: "ltr",
              textAlign: "end",
              "::-webkit-scrollbar-thumb": {
                background: "#126E83",
                // borderRadius: "10px"
              },
              "::-webkit-scrollbar-track": {
                background: "#A7C9D1",
                borderRadius: "10px",
              },
            }}
          >
            <Typography
              fontWeight="bold"
              color="var(--emr-font)"
              fontSize={"20px"}
              mt="15px"
            >
              {"اردو های جاری"}
            </Typography>

            {data?.activeTrips.length >= 1 &&
              data?.activeTrips?.map((item, index) => (
                <Box
                  sx={{ cursor: "pointer" }}
                  // onClick={(e) => {
                  //   if (leader) {
                  //     setAnchorEl(e.currentTarget);
                  //     setDataSelected(item);
                  //   }
                  // }}
                  mt={index === 0 ? "20px" : "15px"}
                  display={"flex"}
                  justifyContent="end"
                >
                  <FlagIcon {...item} />
                  <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                    {item.name}
                  </Typography>
                </Box>
              ))}
          </Box>
        </Box>
        {dataViewGroupInfo.map((item) => (
          <Box
            // mr="10px"
            p="10px"
            bgcolor="#F5F9FF"
            borderRadius="12px"
            minWidth="200px"
            height="170px"
            boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
          >
            <Typography
              fontWeight="bold"
              color="var(--emr-font)"
              fontSize={"20px"}
              mt="15px"
            >
              {item.title}
            </Typography>

            <Box mt={"20px"} mr="10px" display={"flex"}>
              <BorderIcon />
              <Typography mr="8px" fontSize={"14px"} color="#6C6969">
                {"کل"}
              </Typography>
            </Box>
            <Box
              fontSize="45px"
              mt="15px"
              textAlign="center"
              color="var(--emr-disable)"
            >
              {item.count}
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
